/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076

import type { ConcreteRequest } from 'relay-runtime';
export type graphqlHelpersFetchMediaTokenQuery$variables = {
  contentId?: string | null;
  missingContentId?: boolean | null;
  status?: ReadonlyArray<string | null> | null;
};
export type graphqlHelpersFetchMediaTokenQuery$data = {
  readonly content?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly mediaConfiguration: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
};
export type graphqlHelpersFetchMediaTokenQuery = {
  response: graphqlHelpersFetchMediaTokenQuery$data;
  variables: graphqlHelpersFetchMediaTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "missingContentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = [
  {
    "condition": "missingContentId",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentBody",
                    "kind": "LinkedField",
                    "name": "atlas_doc_format",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "EmbeddedMediaToken",
                        "kind": "LinkedField",
                        "name": "mediaToken",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "token"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "MediaConfiguration",
    "kind": "LinkedField",
    "name": "mediaConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "clientId"
      },
      {
        "kind": "ScalarField",
        "name": "fileStoreUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
    "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
    "metadata": {},
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "operationKind": "query",
    "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
  }
};
})();

(node as any).hash = "c53e0852d23c6b17549e89592c16b84c";

export default node;
